module.exports = __webpack_public_path__ + "media/luxury-2026/modern-dining-9aeb5126.jpg";